<template>
  <v-dialog v-model="magedialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="#e85d22 ">
        <v-btn icon dark @click="magedialog = false">
          <v-icon>close</v-icon>
        </v-btn>

        <v-toolbar-title>Upload Product to Magento</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn :disabled='!valid'  color="primary" @click="dialog = false; magentoUpload()">Upload</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container grid-list-md text-xs-center>
        <v-layout row wrap>
          <v-flex md12>
            <div>
              <v-alert
                v-for="(item,index) in errorMessages"
                v-bind:key="index"
                :value="true"
                color="warning"
                icon="priority_high"
                outline
                dismissible
              >{{item}}</v-alert>
            </div>
            <v-dialog v-model="Loadingdialog" persistent width="300">
              <v-card color="primary" dark>
                <v-card-text>
                  Uploading Product to Magento..........
                  <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-flex>
          <v-flex md4 s4 xs12>
            <v-list v-if="assetListData" three-line subheader>
              <v-subheader>Products to be uploaded</v-subheader>
              <v-list-tile
                avatar
                @click="editItem(item);all()"
                v-bind:key="index"
                v-for="(item,index) in magentoModel"
              >
                <v-list-tile-content>
                  <v-list-tile-title>{{item.hardwarespec.Discovery.AssetTag}}</v-list-tile-title>

                  <v-list-tile-sub-title v-if='item.hardwarespec.Discovery.hasOwnProperty("SystemInfo")'>{{item.hardwarespec.Discovery.SystemInfo.Serial}}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-spacer></v-spacer>

                <v-btn icon>
                  <v-icon @click="save()">save</v-icon>
                </v-btn>
              </v-list-tile>
              <v-divider></v-divider>
            </v-list>
          </v-flex>
          <v-flex md8 s8 xs12>
            <v-card color="secondary">
                <v-form ref="form"
                v-model="valid"> 
              
              <v-card>
                <v-container grid-list-md text-xs-center>
                  <v-layout row wrap>
                    <v-expansion-panel v-model="panel" expand>
                      <v-expansion-panel-content>
                        <template v-slot:header>
                          <div>Hardware Spec : {{currentAsset}}</div>
                        </template>
                        <v-card v-if="editedItem">
                          <v-container grid-list-md text-xs-center>
                            <v-layout row wrap>
                              <v-flex d-flex xs12 sm6 md6>
                                <v-text-field
                                v-if='editedItem.hardwarespec.Discovery.hasOwnProperty("SystemInfo")'
                                  v-model="editedItem.hardwarespec.Discovery.SystemInfo.Make"
                                  label="Make"
                                >{{editedItem.hardwarespec.Discovery.SystemInfo.Make}}</v-text-field>
                              </v-flex>
                              <v-flex d-flex xs12 sm6 md6>
                                <v-text-field
                                v-if='editedItem.hardwarespec.Discovery.hasOwnProperty("SystemInfo")'
                                  v-model="editedItem.hardwarespec.Discovery.SystemInfo.Model"
                                  label="Model"
                                >{{editedItem.hardwarespec.Discovery.SystemInfo.Model}}</v-text-field>
                              </v-flex>
                              <v-flex d-flex xs12 sm6 md6>
                                <v-text-field
                                v-if='editedItem.hardwarespec.Discovery.hasOwnProperty("SystemInfo")'
                                  v-model="editedItem.hardwarespec.Discovery.SystemInfo.Serial"
                                  label="Serial"
                                >{{editedItem.hardwarespec.Discovery.SystemInfo.Serial}}</v-text-field>
                              </v-flex>
                              <v-flex d-flex xs12 sm6 md6>
                                <v-text-field
                                v-if='editedItem.hardwarespec.Discovery.hasOwnProperty("CpuTitle")'
                                  v-model="editedItem.hardwarespec.Discovery.CpuTitle"
                                  label="Processor"
                                >{{editedItem.hardwarespec.Discovery.cputitle}}</v-text-field>
                              </v-flex>
                              <v-flex d-flex xs12 sm6 md6>
                                <v-text-field
                                v-if='editedItem.hardwarespec.Discovery.hasOwnProperty("RamTitle")'
                                  type="number"
                                  v-model="editedItem.hardwarespec.Discovery.RamTitle"
                                  label="Memory"
                                >{{editedItem.hardwarespec.Discovery.RamTitle}}</v-text-field>
                              </v-flex>
                              <v-flex d-flex xs12 sm6 md6>
                                <v-text-field
                                v-if='editedItem.hardwarespec.Discovery.hasOwnProperty("HddTitle")'
                                  type="number"
                                  v-model="editedItem.hardwarespec.Discovery.HddTitle"
                                  label="Storage"
                                >{{editedItem.hardwarespec.Discovery.HddTitle}}</v-text-field>
                              </v-flex>

                              <v-flex d-flex xs12 sm6 md6>
                                <v-text-field
                                v-if='editedItem.hardwarespec.Discovery.hasOwnProperty("GraphCardsInfo")'
                                  v-model="editedItem.hardwarespec.Discovery.GraphCardsInfo[0].GraphicCardName"
                                  label="Video Card"
                                >{{editedItem.hardwarespec.Discovery.GraphCardsInfo[0].GraphicCardName}}</v-text-field>
                              </v-flex>

                              <v-flex d-flex xs12 sm6 md6>
                                <v-select
                                  v-model="editedItem.hardwarespec.magento.formFactor"
                                  :items="formFactorArr"
                                  item-text="text"
                                  item-value="value"
                                  label="Form Factor*"
                                >{{editedItem.hardwarespec.magento.formFactor}}</v-select>
                              </v-flex>
                              <v-flex d-flex xs12 sm6 md6>
                                <v-select
                                  v-model="editedItem.hardwarespec.Discovery.scratches"
                                  :items="scratchesArr"
                                  label="Scratches"
                                >{{editedItem.hardwarespec.Discovery.scratches}}</v-select>
                              </v-flex>
                              <v-flex d-flex xs12 sm6 md6>
                                <v-text-field
                                  type="number"
                                  v-model="editedItem.hardwarespec.Discovery.screen"
                                  label="Screen Size"
                                >{{editedItem.hardwarespec.Discovery.screen}}</v-text-field>
                              </v-flex>

                              <v-flex d-flex xs12 sm6 md6>
                                <v-text-field
                                  v-model="editedItem.hardwarespec.magento.weight"
                                  type="number"
                                  label="Weight"
                                >{{editedItem.hardwarespec.magento.weight}}</v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card>
                        <v-card v-else></v-card>
                      </v-expansion-panel-content>
                      <v-expansion-panel-content>
                        <template v-slot:header>
                          <div>Magento Settings</div>
                        </template>
                        <v-card>
                          <v-container grid-list-md text-xs-center v-if="editedItem">
                            <v-layout row wrap>
                              <v-flex d-flex xs12 sm6 md6>
                                <v-select
                                  v-model="editedItem.hardwarespec.magento.enable"
                                  :items="enableList"
                                  item-text="text"
                                  item-value="value"
                                  label="Status"
                                ></v-select>
                              </v-flex>
                              <v-flex d-flex xs12 sm6 md6>
                                <v-text-field
                                  type="number"
                                  v-model="editedItem.hardwarespec.magento.websiteID"
                                  label="Website ID"
                                >{{editedItem.hardwarespec.magento.websiteID}}</v-text-field>
                              </v-flex>
                              <v-flex d-flex xs12 sm6 md6>
                                <v-text-field outline
                                  required
                                   :rules="[v => !!v || 'this field is required']"
                                  v-model="editedItem.hardwarespec.magento.Sku"
                                  label="SKU*"
                                >{{editedItem.hardwarespec.magento.Sku}}</v-text-field>
                              </v-flex>
                              <v-select
                              required
                                   :rules="[v => !!v || 'this field is required']"
                              outline
                                v-model="editedItem.hardwarespec.magento.grade"
                                :items="gradeList"
                                item-text="text"
                                item-value="value"
                                label="Grade*"
                              ></v-select>
                              <v-flex d-flex xs12 sm6 md6>
                                <v-text-field
                                required
                                   :rules="[v => !!v || 'this field is required']"
                                  outline
                                  v-model="editedItem.hardwarespec.magento.listingTitle"
                                  label="Listing Title*"
                                >{{editedItem.hardwarespec.magento.listingTitle}}</v-text-field>
                              </v-flex>
                              <v-flex d-flex xs12 sm6 md6>
                                <v-text-field
                                  v-model="editedItem.hardwarespec.magento.includes"
                                  label="Includes"
                                >{{editedItem.hardwarespec.magento.includes}}</v-text-field>
                              </v-flex>
                              <v-flex d-flex xs12 sm6 md6>
                                <v-select
                                  v-model="editedItem.hardwarespec.magento.camera"
                                  label="Camera?"
                                  :items="trueFalseList"
                                  item-text="text"
                                  item-value="value"
                                >{{editedItem.hardwarespec.magento.isInStock}}</v-select>
                              </v-flex>
                              <v-flex d-flex xs12 sm6 md6>
                                <v-text-field
                                  type="number"
                                  v-model="editedItem.hardwarespec.magento.price"
                                  label="Price"
                                >{{editedItem.hardwarespec.magento.price}}</v-text-field>
                              </v-flex>
                              <v-flex d-flex xs12 sm6 md6>
                                <v-text-field
                                  type="number"
                                  v-model="editedItem.hardwarespec.magento.qty"
                                  label="qty"
                                >{{editedItem.hardwarespec.magento.qty}}</v-text-field>
                              </v-flex>
                              <v-flex d-flex xs12 sm6 md6>
                                <v-select
                                  v-model="editedItem.hardwarespec.magento.isInStock"
                                  label="in stock?"
                                  :items="inStockList"
                                  item-text="text"
                                  item-value="value"
                                >{{editedItem.hardwarespec.magento.isInStock}}</v-select>
                              </v-flex>
                              <v-flex d-flex xs12 sm6 md6>
                                <v-text-field
                                  v-model="editedItem.hardwarespec.magento.description"
                                  label="description"
                                >{{editedItem.hardwarespec.magento.description}}</v-text-field>
                              </v-flex>
                              <v-flex d-flex xs12 sm6 md6>
                                <v-text-field
                                  v-model="editedItem.hardwarespec.magento.short_description"
                                  label="short description"
                                >{{editedItem.hardwarespec.magento.short_description}}</v-text-field>
                              </v-flex>
                              <v-flex d-flex xs12 sm6 md6>
                                <v-text-field
                                  v-model="editedItem.hardwarespec.magento.meta_title"
                                  label="Meta Title"
                                >{{editedItem.hardwarespec.magento.meta_title}}</v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card>
                      </v-expansion-panel-content>
                      <!-- <v-expansion-panel-content
    >
      <template v-slot:header>
        <div>Magento filterable attribute</div>
      </template>
      <v-card >
      <v-container grid-list-md text-xs-center v-if='editedItem'>
        <v-layout row wrap>
             <v-flex d-flex xs12 sm6 md6>
        <v-select
        v-model='editedItem.hardwarespec.magento.filterableHDD'
          :items="filterHDDList"
          item-text="text"
          item-value="value"
          label="Filterable HDD"
        ></v-select>
        </v-flex>
        <v-flex d-flex xs12 sm6 md6>
        <v-select
        v-model='editedItem.hardwarespec.magento.filterableHDDType'
          :items="filterHDDTyoeList"
          item-text="text"
          item-value="value"
          label="Filterable HDD Type"
        ></v-select>
        </v-flex>
        <v-flex d-flex xs12 sm6 md6>
        <v-select
        v-model='editedItem.hardwarespec.magento.filterableRAM'
          :items="filterRamList"
          item-text="text"
          item-value="value"
          label="Filterable RAM"
        ></v-select>
         </v-flex>
        <v-flex d-flex xs12 sm6 md6>
           <v-select
        v-model='editedItem.hardwarespec.magento.filterableCPU'
          :items="filterCPUList"
          item-text="text"
          item-value="value"
          label="Filterable CPU"
        ></v-select>
        </v-flex>
        <v-flex d-flex xs12 sm6 md6>
           <v-select
        v-model='editedItem.hardwarespec.magento.filterableOS'
          :items="filterOSList"
          item-text="text"
          item-value="value"
          label="Filterable OS"
        ></v-select>
        </v-flex>
        <v-flex d-flex xs12 sm6 md6>
           <v-select
        v-model='editedItem.hardwarespec.magento.filterableManu'
          :items="filterManuList"
          item-text="text"
          item-value="value"
          label="Manufacturer"
        ></v-select>
        </v-flex>
        </v-layout>
        </v-container>
      </v-card>
                      </v-expansion-panel-content>-->
                    </v-expansion-panel>
                  </v-layout>
                </v-container>
              </v-card>
                </v-form>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
const fb = require("../firebaseConfig.js");
export default {
  name: "MagentoDetail",
  props: {
    assetList: Array
  },
  data() {
    return {
      valid: true,
      currentAsset : "",
      Loadingdialog: false,
      errorMessages: [],
      panel: [],
      gradeList: [
        { text: "A", value: 37 },
        { text: "B", value: 38 },
        { text: "C", value: 39 },
        { text: "D", value: 40 },
        { text: "E", value: 41 }
      ],
      filterManuList: [
        { text: "Dell", value: 50 },
        { text: "HP", value: 51 },
        { text: "Lenovo", value: 52 },
        { text: "Asus", value: 53 },
        { text: "Acer", value: 54 },
        { text: "Sony", value: 55 },
        { text: "Samsung", value: 56 },
        { text: "Toshiba", value: 57 },
        { text: "Apple", value: 58 },
        { text: "Microsoft", value: 59 },
        { text: "Other", value: 60 }
      ],
      filterOSList: [
        { text: "Windows 7", value: 61 },
        { text: "Windows 10", value: 62 },
        { text: "MAC OS", value: 63 }
      ],
      filterCPUList: [
        { text: "Intel i3", value: 13 },
        { text: "Intel i5", value: 14 },
        { text: "Intel i7", value: 15 },
        { text: "Intel Core 2 Duo", value: 16 },
        { text: "Intel Xeon", value: 17 },
        { text: "AMD", value: 18 }
      ],
      filterRamList: [
        { text: "1GB", value: 19 },
        { text: "2GB", value: 20 },
        { text: "4GB", value: 21 },
        { text: "6GB", value: 22 },
        { text: "8GB", value: 23 },
        { text: "10GB", value: 24 },
        { text: "12GB", value: 25 },
        { text: "16GB", value: 26 },
        { text: "24GB", value: 27 },
        { text: "32GB", value: 28 }
      ],
      filterHDDTyoeList: [
        { text: "SSD", value: 64 },
        { text: "HDD", value: 65 },
        { text: "SSD + HDD", value: 66 }
      ],
      filterHDDList: [
        { text: "80GB SSD", value: 29 },
        { text: "120GB SSD", value: 30 },
        { text: "120GB HDD", value: 31 },
        { text: "160GB HDD", value: 32 },
        { text: "160GB SSD", value: 33 },
        { text: "320GB HDD", value: 34 },
        { text: "500GB HDD", value: 35 },
        { text: "1000GB (1TB) HDD", value: 36 }
      ],
      trueFalseList: [
        { text: "Yes", value: "YES" },
        { text: "No", value: "NO" }
      ],
      editedIndex: null,
      editedItem: null,
      magentoModel: [],
      scratchesArr: ["Yes", "No"],
      formFactorArr: [
        { text: "All in one", value: 42 },
        { text: "Laptop", value: 50 },
        { text: "Large Size", value: 43 },
        { text: "Mid Size", value: 44 },
        { text: "NetBook", value: 45 },
        { text: "Small Form Factor (SSF)", value: 46 },
        { text: "Tablet", value: 47 },
        { text: "Tower/Desktop", value: 48 },
        { text: "Ultra Portable", value: 49 }
      ],
      assetDetail: null,
      inStockList: [
        { text: "In Stock", value: true },
        { text: "Out of Stock", value: false }
      ],
      enableList: [{ text: "Enable", value: 1 }, { text: "Disable", value: 0 }],
      magentoSetting: {
        formFactor: 44,
        weight: 0,
        grade: 37,
        price: 0,
        sku: "",
        listingTitle: "",
        wireless_connectivity: 1,
        enable: 0,
        qty: 1,
        screenSize: "N/A",
        includes: "Mouse and Keyboard",
        camera: "Yes",
        isInStock: true,
        websiteID: 1,
        meta_title: " ",
        short_description: " ",
        description:
          'Professionally Refurbished, Includes 90 Day Warranty\r\nThis HP ProBook 6460B Laptop computer is reliable and secure.\r\n\r\nIt has the following specifications:\r\n\r\nManufacturer: HP\r\nModel: ProBook 6460B\r\nColor: Gray\r\nScreen Size: 13.5"\r\nProcessor / CPU: Core i5 2520M @ 2.50Ghz\r\nMemory / RAM: 8GB\r\nStorage: 500GB\r\nOperating System: Win10\r\nCD/DVD Drive: DVD/CD\r\nUSB Ports: 3\r\nAudio Port: AUX and MIC\r\nDisplay Ports: VGA, Display, Mini Display\r\nEthernet Port:Yes\r\nCharger Included: Yes\r\nOther Notes:Small dents on front, as shown in images and reflected in price.\r\nCODE: UYP86X',
        filterableHDD: null,
        filterableHDDType: null,
        filterableRAM: null,
        filterableCPU: null,
        filterableOS: "62"
      },
      assetListData: this.assetList,
      magedialog: true
    };
  },
  mounted() {
    this.assetListData.forEach(item => {
      console.log(item)
      if (!item.magento) {
        item.magento = this.magentoSetting;
        //Dell Inc. Latitude E7440 Intel(R) Core(TM) i5-4200U CPU @ 1.60GHz, 8 GB RAM, 465 GB HDD
      }
       item.magento.listingTitle = item.Discovery.SystemInfo.Make + " "+ item.Discovery.SystemInfo.Model + " "+  item.Discovery.CpuTitle + " , "+  item.Discovery.RamTitle + " GB RAM" +  ", " + item.Discovery.HddTitle + " GB HDD"
      this.magentoModel.push({
        hardwarespec: item
      });
             
    });
  },
  methods: {
    all() {
      this.panel = [1, 2, 3];
    },
    validateData(data) {
      var isValid = true;

      data.forEach(item => {
        if (item.hardwarespec.magento.Sku === "") {
          this.errorMessages.push(
            "Asset " + item.hardwarespec.Discovery.AssetTag + ": sku is required"
          );
          isValid = false;
        }
        if (item.hardwarespec.magento.listingTitle === "") {
          this.errorMessages.push(
            "Asset " +
              item.hardwarespec.Discovery.AssetTag +
              ": listing title is required"
          );
          isValid = false;
        }
      });
      return isValid;
    },
    magentoUpload() {
      this.Loadingdialog = true;
      if (!this.validateData(this.magentoModel)) {
        this.Loadingdialog = false;
        return;
      }

      this.magentoModel.forEach(item => {
        this.$http
          .get(
            "https://us-central1-tech-reuse.cloudfunctions.net/api/magento/token"
          )
          .then(tok => {
            //payload note for 3r
            //attribute set  : 4
            //list of attr https://devdocs.magento.com/redoc/2.3/admin-rest-api.html#operation/catalogProductRepositoryV1SavePost
            let pl = {
              product: {
                sku: item.hardwarespec.magento.Sku,
                name: item.hardwarespec.magento.listingTitle,
                attribute_set_id: 4,
                price: item.hardwarespec.magento.price,
                status: item.hardwarespec.magento.enable,
                visibility: 4,
                type_id: "simple",
                created_at: this.$moment().format("MM/DD/YYYY HH:mm:ss"),
                updated_at: this.$moment().format("MM/DD/YYYY HH:mm:ss"),
                weight: item.hardwarespec.magento.weight,
                extension_attributes: {
                  //website id is now set to 1 by default
                  //multiple website ID implementation will come in the future if needed
                  website_ids: [item.hardwarespec.magento.websiteID],
                  stock_item: {
                    qty: item.hardwarespec.magento.qty,
                    is_in_stock: item.hardwarespec.magento.isInStock
                  }
                },
                custom_attributes: [
                  // {
                  //     "attribute_code": "filterable_hdd",
                  //     "value": item.hardwarespec.magento.filterableHDD
                  // },
                  // {
                  //     "attribute_code": "filterable_hdd_type",
                  //     "value": item.hardwarespec.magento.filterableHDDType
                  // },
                  // {
                  //     "attribute_code": "filterable_ram",
                  //     "value": item.hardwarespec.magento.filterableRAM
                  // },
                  //  {
                  //     "attribute_code": "filterable_cpu",
                  //     "value": item.hardwarespec.magento.filterableCPU
                  // },
                  // {
                  //     "attribute_code": "filterable_os",
                  //     "value": item.hardwarespec.magento.filterableOS
                  // },
                  // {
                  //     "attribute_code": "manufacturer",
                  //     "value": item.hardwarespec.magento.filterableManu
                  // },
                  {
                    attribute_code: "cpu",
                    value: item.hardwarespec.Discovery.CpuTitle
                  },
                  {
                    attribute_code: "description",
                    value: item.hardwarespec.magento.description
                  },

                  {
                    attribute_code: "camera",
                    value: item.hardwarespec.magento.camera
                  },
                  {
                    attribute_code: "short_description",
                    value: item.hardwarespec.magento.short_description
                  },
                  {
                    attribute_code: "meta_title",
                    value: item.hardwarespec.magento.meta_title
                  },

                  {
                    attribute_code: "ram",
                    value: item.hardwarespec.Discovery.RamTitle
                  },

                  {
                    attribute_code: "hdd",
                    value: item.hardwarespec.Discovery.HddTitle
                  },

                  {
                    attribute_code: "grade",
                    value: item.hardwarespec.magento.grade
                  },

                  {
                    attribute_code: "form_factor",
                    value: item.hardwarespec.magento.formFactor
                  },
                  {
                    attribute_code: "screen_size",
                    value: item.hardwarespec.magento.screenSize
                  },
                  {
                    attribute_code: "wireless_connectivity",
                    value: item.hardwarespec.magento.wireless_connectivity
                  },
                  {
                    attribute_code: "includes",
                    value: item.hardwarespec.magento.includes
                  }
                ]
              }
            };

            var payload = {
              token: tok.data,
              payload: pl
            };
            this.$http
              .post(
                "https://us-central1-tech-reuse.cloudfunctions.net/api/magento/listing",
                payload,
                {
                  headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    "Access-Control-Allow-Origin": "*"
                  }
                }
              )
              .then(() => {
                this.snackMessage =
                  "Listing has been uploaded to Magento Store";
                this.snackbar = true;
                this.Loadingdialog = false;
              }).catch(()=>{
                 this.snackMessage =
                  "Error";
                this.snackbar = true;
                this.Loadingdialog = false;
              });
          });
      });
    },
    editItem(item) {
      this.currentAsset = item.hardwarespec.Discovery.AssetTag
      this.editedIndex = this.magentoModel
        .map(e => {
          return e.hardwarespec.Discovery.AssetTag;
        })
        .indexOf(item.hardwarespec.Discovery.AssetTag);
      this.editedItem = item;
    },
    save() {
      this.magentoModel[this.editedIndex] = this.editedItem;
      fb.AssetsCollections.doc(
        this.editedItem.hardwarespec.Discovery.AssetTag
      ).update({
        magento: this.editedItem.hardwarespec.magento
      });
    }
  },
  watch: {
    magedialog: function(val) {
      if (val === false) {
        this.$emit("mageModalclose");
      }
    }
  }
};
</script>
